export interface SegmentedOption<T extends string> {
  label: string;
  value: T;
}

interface SegmentedProps<T extends string> {
  options: SegmentedOption<T>[];
  value: T;
  onChange: (value: T) => void;
  block?: boolean;
  className?: string;
}

/** Custom segmented control — replaces antd Segmented. */
export default function Segmented<T extends string>({
  options,
  value,
  onChange,
  block = false,
  className = '',
}: SegmentedProps<T>) {
  return (
    <div
      role="tablist"
      className={[
        'flex gap-1 rounded-lg bg-brand-shade p-1',
        block ? 'w-full' : 'w-fit',
        className,
      ].join(' ')}
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(opt.value)}
            className={[
              'rounded-md px-4 py-2 text-sm font-medium transition-all',
              block ? 'flex-1' : '',
              active
                ? 'bg-brand text-white shadow-btn'
                : 'text-ink-secondary hover:text-brand',
            ].join(' ')}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
